export function formatClock(d = new Date()): string {
  let h = d.getHours();
  const m = d.getMinutes().toString().padStart(2, '0');
  const am = h < 12;
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${am ? 'AM' : 'PM'}`;
}

export function startClock(tick: (text: string) => void): () => void {
  const fire = () => tick(formatClock());
  fire();
  const id = window.setInterval(fire, 15_000);
  return () => window.clearInterval(id);
}
